// extracted by mini-css-extract-plugin
module.exports = {"badgeContainer":"az_V6c","badgeV2":"az_W6c","badgeText":"az_X6c","badgeContainerEnd":"az_Y6c","badgeHashMarks":"az_Z6c","badgeHashMark":"az__6c"};